var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modelCanvas",attrs:{"id":_vm.containerId}},[(_vm.toolbarEnable)?_c('ModelToolbar',{attrs:{"bench":_vm.benchId,"canvasId":_vm.modelId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }